module.exports = __webpack_public_path__ + "static/media/19ESCAP31.f3b5aa26.jpg";